import { getElementControls } from "core-integration/src/store/elements/reducers";
import { getTeams } from "core-integration/src/store/teams/reducers";
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { FieldWrap, SelectField } from "../../FieldRenderers";

type Props = WithTranslation & {
  handleFilterChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

const ElementFilter = ({ handleFilterChange, t }: Props) => {
  const teams = useSelector(getTeams);
  const controls = useSelector(getElementControls);

  const filterTeams = teams
    .filter((team: any) => team.unavailable === false)
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <FieldWrap>
      <SelectField
        id="filter"
        name="filter"
        label={t("xStats.elementFilter.view", "Filter by team")}
        value={controls.filter}
        onChange={handleFilterChange}
        required={false}
      >
        <>
          <option value="all" aria-selected={controls.filter === "all"}>
            {t("xStats.elementFilter.allTeams", "All teams")}
          </option>
          {filterTeams.map((o) => (
            <option
              key={`te_${o.id}`}
              value={`te_${o.id}`}
              aria-selected={controls.filter === `te_${o.id}`}
            >
              {o.name}
            </option>
          ))}{" "}
        </>
      </SelectField>
    </FieldWrap>
  );
};

export default withTranslation()(ElementFilter);
